// extracted by mini-css-extract-plugin
export default {"activityStyles":"styles__activityStyles___CodMw","activityBlock":"styles__activityBlock___gl914","reviewModeBlock":"styles__reviewModeBlock___Iptpn"};